import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    provider: PropTypes.object,
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    plans: PropTypes.array
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { provider } = this.context
    const { plans } = this.props
    return {
      title: 't(New Signup Page)',
      method: 'POST',
      action: '/api/admin/truevail/admin/signup_pages',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Title)', 
              name: 'title', 
              type: 'textfield', 
              required: true 
            },
            {
              label: 't(Entity)',
              name: 'entity_type',
              type: 'dropdown',
              options: [
                { value: 'advisor', text: 't(Advisor)' },
                { value: 'agency', text: 't(Agency)' },
                { value: 'supplier', text: 't(Supplier)' }
              ],
              defaultValue: 'advisor'
            },
            { 
              label: 't(URL)', 
              name: 'permalink', 
              type: 'permalinkfield', 
              prefix: '/signup',
              host: provider.admin_host, 
              placeholder: '/path/to/signup' 
            }
          ]
        },
        {
          label: 't(Details)',
          fields: [
            { 
              label: 't(Pro)',
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    {
                      label: 't(Monthly Plan)',
                      name: 'config.pro.monthly_plan_id',
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('month') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} ($${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true
                    },
                    {
                      label: 't(Yearly Plan)',
                      name: 'config.pro.yearly_plan_id',
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('year') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} ($${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true
                    }
                  ]
                }
              ]
            },
            { 
              label: 't(Essentials)',
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    {
                      label: 't(Monthly Plan)',
                      name: 'config.essentials.monthly_plan_id',
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('month') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} (${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true
                    },
                    {
                      label: 't(Yearly Plan)',
                      name: 'config.essentials.yearly_plan_id',
                      type: 'dropdown',
                      options: plans.filter(plan => {
                        return plan.title.search('year') >= 0
                      }).map(plan => ({
                        value: plan.id,
                        text: `${plan.title} (${plan.price} / ${plan.frequency.units})`
                      })),
                      required: true
                    }
                  ]
                }
              ]
            },
            { 
              label: 't(Logo)',
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    { label: 't(Price)', 
                      name: 'config.logo.price', 
                      type: 'moneyfield', 
                      required: true
                    },
                    { 
                      label: 't(Discounted Price)', 
                      name: 'config.logo.discount_price', 
                      type: 'moneyfield'
                    }
                  ]
                }
              ]
            },
            { 
              label: 't(Brand)',
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    { label: 't(Price)', 
                      name: 'config.brand.price', 
                      type: 'moneyfield', 
                      required: true
                    },
                    { 
                      label: 't(Discounted Price)', 
                      name: 'config.brand.discount_price', 
                      type: 'moneyfield'
                    }
                  ]
                }
              ]
            },
            { 
              label: 't(Single Page Website)',
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    { label: 't(Price)', 
                      name: 'config.singlepage.price', 
                      type: 'moneyfield', 
                      required: true
                    },
                    { 
                      label: 't(Discounted Price)', 
                      name: 'config.singlepage.discount_price', 
                      type: 'moneyfield'
                    }
                  ]
                }
              ]
            },
            { 
              label: 't(Seven Page Website)',
              type: 'segment',
              fields: [
                {
                  type: 'fields',
                  fields: [
                    { label: 't(Price)', 
                      name: 'config.sevenpage.price', 
                      type: 'moneyfield', 
                      required: true
                    },
                    { 
                      label: 't(Discounted Price)', 
                      name: 'config.sevenpage.discount_price', 
                      type: 'moneyfield'
                    }
                  ]
                }
              ]
            },
            {
              label: 't(Setup Fee)',
              name: 'config.setup_fee',
              type: 'moneyfield',
              required: true,
              defaultValue: 0.00
            },
            {
              label: 't(Free Setup)',
              name: 'config.free_setup',
              type: 'checkbox',
              defaultValue: true
            },
            {
              label: 't(Trial Length)',
              name: 'config.trial_length',
              type: 'numberfield',
              required: true,
              defaultValue: 1
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(signup_page) {
    this.context.router.push(`/admin/truevail/admin/signup_pages/${signup_page.id}`)
    this.context.modal.close()
  }

}

const mapResources = (props, context) => ({
  plans: '/api/admin/subscriptions/services/3/plans'
})

export default Container(mapResources)(New)

